import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_HERO_EXPERIMENT = defineFcm('homepage_hero_experiment')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		deprecated:
			'Superseded by GrowthBook homepage_hero_experiment (CHANGE-95295) — rollout is now dashboard-managed, no FCM gating. Safe to delete after 2026-08-04.',
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context: 'Homepage hero',
		description:
			'Gates the homepage hero experiment, which now covers all three homepage hero variants (default, SAP, TikTok-to-Draft). Used by the homepage_hero_experiment experiment (CHANGE-95295).',
		import: false,
	});
